export const productsKeys = {
  all: ["products"],
  lists: () => [...productsKeys.all, "list"],
  list: (params) => [...productsKeys.lists(), params ?? {}],
  details: () => [...productsKeys.all, "detail"],
  detail: (documentId) => [...productsKeys.details(), documentId],
};
